/**
 * The first month Revelio's modelled employee sentiment covers.
 *
 * SHARED because two independent readers must floor at the same month or they
 * describe different datasets: the Sentiment page's own filter builder
 * (`get-sentiment-v3-variables.ts`, which clamps every non-snapshot request to
 * it) and the assistant's server-side sentiment read
 * (`build-sentiment-req.ts`). Reading earlier returns a leading run of empty
 * months, which a chart draws as a collapse and a narration describes as one.
 */
export const SENTIMENT_MIN_START_MONTH = '2020-01';
